import { FuseAnimate, FusePageCarded } from "@fuse";
import Loading from "@fuse/components/FuseLoadable/Loading";
import _ from "@lodash";
import { Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import React from "react";
import Countdown from "../../../../Components/Countdown/Countdown";
import ToolbarFiltro from "../../Components/ToolbarFiltro";
import ComunicadorNewButton from "../../ComunicadorNewButton";
import CentralNotificacoesDialog from "./Dialog";
import CentralNotificacoesListagem from "./Listagem";
import CentralNotificacoesResultadoPesquisa from "./ResultadoPesquisa";
import CentralNotificacoesSidebarEsquerda from "./SidebarEsquerda";
import { MdMail } from "react-icons/md";

const styles = theme => ({
    toolbar: {
        backgroundColor: theme.palette.background.default,
    }
});

class CentralNotificacoes extends XAPPComponent {

    state = {
        "openPainel": true,
        "idlocal": null,
        "tagsOR": [],
        "tagsAND": [],
        "filtro": "",
        "updated": new Date().getTime(),
        "showPesquisa": false,
    };

    componentDidMount() {
        this.getInsumos();
    }

    componentDidUpdate(prevProps, prevState) {
        const form = { ...this.state };
        if (!_.isNull(form.idlocal) && !_.isEqual(prevState.idlocal, form.idlocal)) {
            this.listFilter(this.getFiltro(form));
            this.setState(_.set({
                ...this.state,
                "tagsOR": [],
                "tagsAND": [],
                "filtro": "",
                "showPesquisa": false,
                "updated": new Date().getTime()
            }));
        }

        if (form.forceUpdate) {
            this.listFilter(this.getFiltro(form));
            this.setState(state => ({ ...state, "forceUpdate": false }));
        }
    }

    setOpenPainel = (_AValue) => {
        this.setState(_.set({ ...this.state }, "openPainel", _AValue));
    };

    setLocal = (_AValue) => {
        this.setState(_.set({ ...this.state }, "idlocal", _AValue));
        this.props.setOpenMessage();
    };

    setLocalTag = (_AKey, _AValue) => {
        let ATags = [...this.state[_AKey]];
        if (ATags.includes(_AValue)) {
            ATags = _.filter(ATags, x => x !== _AValue);
        }
        else {
            ATags.push(_AValue);
        }

        this.setState(_.set({ ...this.state, [_AKey]: ATags, "forceUpdate": true, "updated": new Date().getTime() }));
        this.props.setOpenMessage();
    };

    setMultiFiltro = (_AString = "", _AValue = []) => {
        let ATags = [];
        _AValue.forEach(item => {
            ATags.push(item);
        });

        this.setState(_.set({ ...this.state, "idlocal": null, "filtro": _AString, "tagsAND": ATags, "forceUpdate": true, "showPesquisa": true }));
    };

    getInsumos = (_ALocaisAND = null) => {
        const { xappRouteParams, getInsumos } = this.props;
        getInsumos(xappRouteParams, _ALocaisAND);
    };

    listFilter = (_AFilter, _APagina) => {
        const { xappRouteParams, list } = this.props;
        list("SELECIONAR", xappRouteParams, _AFilter, _APagina);
    };

    getFiltro = (_AState) => {
        let AFiltros = {
            "procedure": "spvwmensagemcentral",
            "isCentral": true,
            "OR": [],
            "AND": [{ "Campo": "mensagemlocal.idlocal", "Operador": "=", "Valor": _AState.idlocal }]
        };
        if (!_.isNull(_AState.tagsOR) && _AState.tagsOR.length > 0) {
            AFiltros.AND.push({ "Campo": "mensagemtag.idparent", "Operador": "IN", "Valor": "(" + _AState.tagsOR.join(", ") + ")" });
        }

        if (!_.isNull(_AState.tagsAND) && _AState.tagsAND.length > 0) {
            _AState.tagsAND.forEach(id => {
                AFiltros.AND.push({ "Campo": "mensagemtag.idparent", "Operador": "=", "Valor": id });
            });
        }

        if (!_.isNull(_AState.filtro) && _AState.filtro.length > 0) {
            AFiltros.OR.push({ "Campo": "mensagem.remetente", "Operador": "LIKE", "Valor": "%" + _AState.filtro + "%" });
            AFiltros.OR.push({ "Campo": "mensagem.assunto", "Operador": "LIKE", "Valor": "%" + _AState.filtro + "%" });
        }
        return AFiltros;
    };

    getTags = () => {
        const { idlocal } = this.state;
        const { locais } = this.props.Comunicador;

        if (!_.isNull(idlocal)) {
            let ATags = _.find(locais, { idlocal: idlocal })?.tags;
            if (!_.isUndefined(ATags) && !_.isNull(ATags)) {
                return ATags;
            }
        }
        return [];
    };

    save = (_AValue, _AAction) => {
        const { save, xappRouteParams } = this.props;
        save(_AValue, xappRouteParams, _AAction, this.getFiltro(this.state));
    };

    getMensagens = (_AIDLocal) => {
        let AResponse = [];
        const { Comunicador = null } = this.props;
        if (!_.isNull(Comunicador) && !_.isNull(Comunicador.central)) {
            Comunicador.central.forEach(item => {
                if (_.isNull(_AIDLocal) ||
                    ((_AIDLocal === -1 && item.usrins === sessionStorage.getItem("username")) ||
                        (_AIDLocal !== -1 && _AIDLocal === item.idlocal))) {
                    AResponse.push(item);
                }
            });
        }
        return AResponse;
    };

    getFilter = (_AAction, xappRouteParams, _AFilter) => {
        this.props.get(_AAction, xappRouteParams, { ..._AFilter, isCentral: true });
    };

    nextPage = () => {
        const { Comunicador } = this.props;
        const form = this.state;
        if (Comunicador.pagina < Comunicador.paginas) {
            this.listFilter(this.getFiltro(form), Comunicador.pagina + 1);
        }
    };

    updateDataLeitura = (_AValue, _AData = null) => {
        if (_.isNull(_AData)) {
            _AData = new Date().toISOString();
        }
        this.save({ "idmensagem": _AValue.idmensagem, "idmensagemlocal": _AValue.idmensagemlocal, "dataleitura": _AData }, "UPDATEDATALEITURA");
    };

    render() {
        const { preload = false, theme, classes, Comunicador, showContent = true, xappRouteParams } = this.props;
        const form = this.state;

        return (
            <React.Fragment>
                {showContent &&
                    <FusePageCarded
                        classes={{
                            contentWrapper: "p-0",
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: clsx("border-0", form.openPainel ? "w-208" : "w-56"),
                            header: "w-full min-h-48 h-48 max-h-48 flex",
                            topBg: "min-h-48 h-48",
                            sidebarHeader: "min-h-48 h-48",
                            toolbar: classes.toolbar,
                            contentCard: "mx-6"
                        }}
                        header={
                            <div className="w-full flex items-center">
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Typography className=" sm:flex text-white items-center" variant="h6">
                                        <MdMail className="text-24 text-white mx-8" />
                                        {"Central de notificações"}
                                    </Typography>
                                </FuseAnimate>
                                <div className="flex-1" />
                                {!_.isNull(Comunicador.data) && _.isNull(Comunicador.open) &&
                                    <React.Fragment>
                                        <Countdown
                                            time={60 * 2}
                                            showButton={true}
                                            callback={() => {
                                                this.props.setOpenMessage();
                                                this.getInsumos();
                                            }}
                                            texto="Atualizando em"
                                            className="text-11 text-white mr-12"
                                        />
                                    </React.Fragment>
                                }
                                {!_.isNull(Comunicador.data) && !_.isNull(Comunicador.open) &&
                                    <React.Fragment>
                                        <Countdown
                                            time={15}
                                            showButton={true}
                                            callback={() => this.listFilter(this.getFiltro(form))}
                                            texto="Atualizando em"
                                            className="text-11 text-white mr-12"
                                        />
                                    </React.Fragment>
                                }
                            </div>
                        }
                        contentToolbar={
                            <React.Fragment>
                                <ComunicadorNewButton
                                    xappRouteParams={xappRouteParams}
                                >
                                    <XAPPButton
                                        color="primary"
                                        aria-label="add"
                                        onClick={() => { }}
                                        className={"text-24"}
                                        type="icon"
                                        icon="add"
                                    />
                                </ComunicadorNewButton>
                                <ToolbarFiltro
                                    setMultiFiltro={this.setMultiFiltro}
                                    Tags={this.getTags()}
                                    updated={form.updated}
                                />
                            </React.Fragment>
                        }
                        leftSidebarHeader={
                            <div />
                        }
                        leftSidebarContent={
                            <CentralNotificacoesSidebarEsquerda
                                locais={Comunicador.locais}
                                setOpenPainel={this.setOpenPainel}
                                parametros={form}
                                setLocal={this.setLocal}
                                setLocalTag={this.setLocalTag}
                                theme={theme}
                                getInsumos={this.getInsumos}
                            />
                        }
                        content={
                            <React.Fragment>
                                {preload && _.isNull(Comunicador.open) ?
                                    <div className="py-160">
                                        <Loading pastDelay={true} />
                                    </div>
                                    :
                                    <React.Fragment>
                                        {form.showPesquisa ?
                                            <CentralNotificacoesResultadoPesquisa
                                                getFilter={this.getFilter}
                                                {...this.props}
                                                xappRouteParams={xappRouteParams}
                                                data={this.getMensagens(null)}
                                                parametros={form}
                                                locais={Comunicador.locais}
                                                save={this.save}
                                                callback={() => this.listFilter(this.getFiltro(form))}
                                            />
                                            :
                                            <CentralNotificacoesListagem
                                                getFilter={this.getFilter}
                                                {...this.props}
                                                xappRouteParams={xappRouteParams}
                                                data={this.getMensagens(form.idlocal)}
                                                parametros={form}
                                                locais={Comunicador.locais}
                                                save={this.save}
                                                idlocal={form.idlocal}
                                                updated={form.updated}
                                                nextPage={this.nextPage}
                                                callback={() => this.listFilter(this.getFiltro(form))}
                                                updateDataLeitura={this.updateDataLeitura}
                                            />
                                        }
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                }
                <CentralNotificacoesDialog
                    xappRouteParams={xappRouteParams}
                    save={this.save}
                />
            </React.Fragment>
        );
    }
}


export default withStyles(styles, { withTheme: true })(CentralNotificacoes);
